var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FDAB29"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 19,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14.2682,
    width: 4.62192,
    height: 16.1767,
    rx: 2.31096,
    transform: "rotate(-45 13 14.2682)",
    fill: "#FDAB29"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62192,
    height: 16.1767,
    rx: 2.31096,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 37.3711 14.2682)",
    fill: "#FDAB29"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 17,
    rx: 2.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 27.5 22)",
    fill: "#FDAB29"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 17,
    rx: 2.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 16.5 24)",
    fill: "#FDAB29"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 17,
    rx: 2.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 16.5 31)",
    fill: "#FDAB29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYenIcon);
export default __webpack_public_path__ + "static/media/yen-Icon.c698abaa1d98302dfe96a78fecdc4207.svg";
export { ForwardRef as ReactComponent };